// StatusTag.tsx
import React from 'react';
import styles from './StatusTag.module.scss';
import type { SubscriptionStatus } from '../../../utils/types';

interface StatusTagProps {
  status:
    | 'active'
    | 'draft'
    | 'paused'
    | 'inactive'
    | 'published'
    | 'blocked'
    | 'whitelisted'
    | 'completed'
    | 'failed'
    | 'in_progress'
    | 'paid'
    | 'pending'
    | 'cancelled'
    | SubscriptionStatus;
}

const StatusTag: React.FC<StatusTagProps> = ({ status }) => {
  return (
    <span className={`${styles.statusTag} ${styles[status]}`}>
      {status.charAt(0).toUpperCase() + status.slice(1)}
    </span>
  );
};

export default StatusTag;
